import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { queryCategoryTopItems } from '../../common/blog-api/queryCategoryItems';
import EcoLink from 'eco-design/base/eco-link';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoImg from 'eco-design/base/eco-img';
import { getBlogTagFromList } from '../../common/utils';
import BlogTimer from '../../common/blog-timer';

const defaultUserIcon = 'https://websiteoss.ecoflow.com/upload/image/1735782674645/logo.svg';

export default function Content({ id, data }: any) {
    const { items = [] } = data;
    const { locale = 'us' } = useRouter();
    let items2 = items.slice(0, 4);
    items2 = items2.map((item: any) => {
        let thePage = { blogImgPc: '', blogTitle: '' }
        const tagItem = getBlogTagFromList(item.blogTagList || [], '');
        try {
            thePage = JSON.parse(item.thePage);
        } catch (e) { }
        return {
            ...item,
            pc: thePage.blogImgPc,
            title: thePage.blogTitle,
            href: item.seoUrl,
            label: tagItem.tag,
            timer: BlogTimer(item.newFirstReleaseTime || item.firstReleaseTime, locale)
        }
    });
    const [itemsA, setItemsA] = useState(items2);

    useEffect(() => {
        async function fetchData() {
            const dataA = await queryCategoryTopItems(locale, { page: 1, size: 4 });
            const items = dataA.items.map((item: any) => {
                let thePage = { blogImgPc: '', blogTitle: '' }
                const tagItem = getBlogTagFromList(item.blogTagList || [], '');
                try {
                    thePage = JSON.parse(item.thePage);
                } catch (e) { }
                return {
                    ...item,
                    pc: thePage.blogImgPc,
                    title: thePage.blogTitle,
                    href: item.seoUrl,
                    label: tagItem.tag,
                    timer: BlogTimer(item.newFirstReleaseTime || item.firstReleaseTime, locale)
                };
            });
            setItemsA(items)
        }
        if (items.length === 0) {
            fetchData();
        }
    }, []);

    return (
        <GloLayout className="editor-blog-category-d" id={id}>
            {itemsA.length &&
                <div className="editor-blog-category-d-content">
                    <div className="editor-blog-category-d-left">
                        {itemsA.slice(0, 1).map((item: any, index: number) => {

                            return (
                                <div key={index}>
                                    <EcoLink href={item.href} className={`editor-blog-category-d-img`}>
                                        <EcoImgVideo isVideo={item.isVideo} pc={item.pc} />
                                    </EcoLink>
                                    <div className={`editor-blog-category-d-msg`}>
                                        <EcoLink href={item.categoryHref} className={`editor-blog-category-d-label`}>
                                            {item.label}
                                        </EcoLink>
                                        <EcoLink href={item.href} className={`editor-blog-category-d-title`}>
                                            {item.title}
                                        </EcoLink>
                                        <div className={`editor-blog-category-d-footer`}>
                                            <div className={`editor-blog-category-d-footer-icon`}>
                                                <EcoImg pc={defaultUserIcon} />
                                            </div>
                                            <div className={`editor-blog-category-d-footer-logo`}>{item.userName || 'EcoFlow'}</div>
                                            <div className={`editor-blog-category-d-footer-time`}>{item.timer}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="editor-blog-category-d-right">
                        {itemsA.slice(1, 4).map((item: any, index: number) => {
                            return (
                                <div key={index} className={`editor-blog-category-d-right-item`}>
                                    <EcoLink href={item.href} className={`editor-blog-category-d-img`}>
                                        <EcoImgVideo isVideo={item.isVideo} pc={item.pc} />
                                    </EcoLink>
                                    <div className={`editor-blog-category-d-msg`}>
                                        <EcoLink href={item.categoryHref} className={`editor-blog-category-d-label`}>
                                            {item.label}
                                        </EcoLink>
                                        <EcoLink href={item.href} className={`editor-blog-category-d-title`}>
                                            {item.title}
                                        </EcoLink>
                                        <div className={`editor-blog-category-d-footer`}>
                                            <div className={`editor-blog-category-d-footer-icon`}>
                                                <EcoImg pc={defaultUserIcon} />
                                            </div>
                                            <div className={`editor-blog-category-d-footer-logo`}>{item.userName || 'EcoFlow'}</div>
                                            <div className={`editor-blog-category-d-footer-time`}>{item.timer}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            }

        </GloLayout>
    );
}



